import React from 'react';
// import LineIcon from "react-lineicons";
import {Cpu, Camera, Smartphone, Image, Grid, Globe, Radio, Underline, Layout} from 'react-feather';
import { Fade } from 'react-awesome-reveal';

function Service({children, content}){

  const renderAuthButton = (name)=>{
    switch(name){
      case 'cpu': return <Cpu size={42}/>
      case 'mobile': return <Smartphone size={42}/>
      case 'camera': return <Camera size={42}/>
      case 'image': return <Image size={42}/>
      case 'grid': return <Grid size={42}/>
      case 'globe': return <Globe size={42}/>
      case 'radio': return <Radio size={42}/>
      case 'layout': return <Layout size={42}/>
      default: return <Underline size={42} />
      // default: return <LineIcon name={content.icon} />
    }
  }

  return (
    <Fade wait={50} bottom>
      <div className="mi-service">
        <span className="mi-service-icon">
          {renderAuthButton(content.icon)}
        </span>
        <h5>{content.title}</h5>
        <p>{content.details}</p>
      </div>
    </Fade>
  )
}

export default Service;
